(function () {
  function renderRecommendations(container, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var recs = parsed.querySelector('.cart-drawer-recs');

    container.innerHTML = recs ? recs.outerHTML : '';
  }

  function fetchRecommendations(productId) {
    var container = document.getElementById('CartDrawer-Recommendations');
    if (!container || !productId) return;

    var baseUrl = container.dataset.url;
    if (!baseUrl) return;

    var url =
      baseUrl +
      '?section_id=cart-drawer-recommendations' +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=10';

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        // Re-query the container instead of reusing the reference captured
        // above: an add-to-cart re-renders #CartDrawer (and everything
        // inside it, including this container) before this fetch resolves,
        // so the original node may already be detached from the page.
        var liveContainer = document.getElementById('CartDrawer-Recommendations');
        if (liveContainer) renderRecommendations(liveContainer, html);
      })
      .catch(function (error) {
        console.error('Recommendations Error:', error);
      });
  }

  function loadRecommendations() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items.length) return;

        // Last added product
        var lastItem = cart.items[cart.items.length - 1];

        console.log('Last Added Product ID:', lastItem.product_id);

        fetchRecommendations(lastItem.product_id);
      })
      .catch(function (error) {
        console.error('Cart Error:', error);
      });
  }

  // Initial load
  loadRecommendations();

  // Reload recommendations whenever cart updates (if supported by theme)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      loadRecommendations();
    });
  }
})();